import PropTypes from 'prop-types';
import React from 'react';
import Rodal from 'rodal';
import styled from 'react-emotion';

import Button from '../../Buttons/Button';
import { CATEGORY, TIER } from '../../Buttons/constants';
import trashIcon from '../../../assets/images/icons/trash.svg';
import { H1, Paragraph } from '../../Text/Text';
import Style from '../../../styles/common';
import TextButton from '../../Buttons/TextButton';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const Content = styled('div')`
  text-align: center;
`;

const Image = styled('img')`
  width: 60px;
`;

const Heading = styled(H1)`
  margin-top: ${Style.SPACING.L};
`;

const ConfirmationMessage = styled(Paragraph)`
  margin-top: ${Style.SPACING.L};
`;

const EventName = styled('span')`
  background-color: ${Style.color.HIGHLIGHT};
  border-radius: ${Style.BORDER_RADIUS};
  display: inline-block;
  margin: ${Style.SPACING.M} 0;
  padding: ${Style.SPACING.XXS};
`;

const Buttons = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const DeleteButton = styled(Button)`
  margin-left: ${Style.SPACING.S};
`;

function DeleteModal(props) {
  return (
    <Rodal
      customStyles={{ padding: Style.SPACING.XL }}
      height={475}
      onClose={props.onClose}
      visible={props.visible}
      width={500}
    >
      <Container>
        <Content>
          <Image src={trashIcon} />
          <Heading>Are you sure?</Heading>
          <ConfirmationMessage>
            You have requested to delete:
            <br />
            <EventName>{props.eventTitle}</EventName>
          </ConfirmationMessage>
          <Buttons>
            <TextButton onClick={props.onClose} tier={TIER.SECONDARY}>
              I want to keep it
            </TextButton>
            <DeleteButton
              category={CATEGORY.DANGER}
              onClick={props.onDelete}
            >
              Delete my event
            </DeleteButton>
          </Buttons>
        </Content>
      </Container>
    </Rodal>
  );
}

DeleteModal.propTypes = {
  eventTitle: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

DeleteModal.defaultProps = {
  isVisible: false,
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/Modals/DeleteModal/DeleteModal.js